"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseFile = parseFile;
exports.inputsToFile = inputsToFile;
const property_1 = require("@genesys/property");
const Inputs = __importStar(require("./inputs"));
function parseFile(data) {
    const fieldGroups = data[0]
        .map((name, groupBegin) => ({ name, groupBegin }))
        .filter(({ name }) => !!name)
        .map(({ name, groupBegin }, i, array) => {
        const nextGroup = array[i + 1];
        const groupEnd = nextGroup && nextGroup.groupBegin;
        return { name, groupBegin, groupEnd };
    });
    return data.slice(2).map((propertyValueStrings) => {
        const parsedFields = fieldGroups
            .map(({ groupBegin, groupEnd }) => {
            const fieldNames = data[1].slice(groupBegin, groupEnd);
            const properties = fieldNames.map((name2, fieldIndex) => ({
                name: name2,
                propertyValueString: propertyValueStrings[groupBegin + fieldIndex]
            }));
            const propertyValueSet = properties.reduce((soFar, next) => property_1.PropertyValueSet.merge(soFar, property_1.PropertyValueSet.fromProperty(next.name, property_1.PropertyValue.fromString(next.propertyValueString))), property_1.PropertyValueSet.Empty);
            return propertyValueSet;
        })
            .reduce((soFar, next) => property_1.PropertyValueSet.merge(soFar, next), property_1.PropertyValueSet.Empty);
        return parsedFields;
    });
}
function inputsToFile(inputs, fanCurvePoints) {
    const groupRow = [];
    const headerRow = [];
    const valueRow = [];
    // --- Handle Inputs.inputs
    for (const fieldGroup of Inputs.inputs) {
        const groupName = fieldGroup.groupName;
        const propertyNames = fieldGroup.propertyNames;
        let first = true;
        for (const propertyName of propertyNames) {
            // Group row: only first column gets the group name
            groupRow.push(first ? groupName : "");
            first = false;
            // Header row
            headerRow.push(propertyName);
            // Value row
            const value = property_1.PropertyValueSet.getValue(propertyName, inputs);
            valueRow.push(value != null ? property_1.PropertyValue.toString(value) : "");
        }
    }
    // --- Handle fanCurvePoints
    let pointIndex = 1;
    for (const point of fanCurvePoints) {
        const pointGroupName = `point${pointIndex}`;
        // Determine property names for this point
        const propertyNames = Object.keys(point); // Or a fixed list if needed
        let first = true;
        for (const propertyName of propertyNames) {
            // Group row: only first column of this point
            groupRow.push(first ? pointGroupName : "");
            first = false;
            // Header row: prefixed with point index
            headerRow.push(`${pointGroupName}${propertyName}`);
            // Value row
            const value = property_1.PropertyValueSet.getValue(propertyName, point);
            valueRow.push(value != null ? property_1.PropertyValue.toString(value) : "");
        }
        pointIndex++;
    }
    return [groupRow, headerRow, valueRow];
}
//# sourceMappingURL=csv-file-handling.js.map